import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import {
    TransitionTarget,
    AnimationLabel,
    ImplementationType, TransitionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { IAnimationSetting, ISwitchTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionConfig } from '@src/slide/domain/ui-model/element-modeles/transition/config';
import { SwitchDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/switch-direction';
import { SwitchDirectionType } from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export class SwitchTransitionModel extends BaseTransitionModel<ISwitchTransition> implements ISwitchTransition {
    public type = TransitionType.SWITCH;
    public direction: SwitchDirection;

    public getAnimationSetting(isSwitchForward?: boolean): IAnimationSetting[] {
        const direction = this.direction.getDirectionType(isSwitchForward);
        if (direction === SwitchDirectionType.LEFT) {
            // 切换——向左
            return [{
                fromStyle: {
                    ...TransitionConfig.SWITCH_START,
                    ...TransitionConfig.Z_INDEX_LEVEL_1,
                },
                toStyle: {
                    ...TransitionConfig.SWITCH_LEFT_MIDDLE,
                    ...TransitionConfig.Z_INDEX_LEVEL_1,
                    duration: this.animationDuration / 2,
                },
                target: TransitionTarget.EXIT,
            }, {
                fromStyle: {
                    ...TransitionConfig.SWITCH_LEFT_MIDDLE,
                    ...TransitionConfig.Z_INDEX_LEVEL_0,
                },
                toStyle: {
                    ...TransitionConfig.SWITCH_END,
                    ...TransitionConfig.Z_INDEX_LEVEL_0,
                    duration: this.animationDuration / 2,
                },
                target: TransitionTarget.EXIT,
                label: AnimationLabel.NEXT,
            }, {
                fromStyle: {
                    ...TransitionConfig.SWITCH_END,
                    ...TransitionConfig.Z_INDEX_LEVEL_0,
                },
                toStyle: {
                    ...TransitionConfig.SWITCH_RIGHT_MIDDLE,
                    ...TransitionConfig.Z_INDEX_LEVEL_0,
                    duration: this.animationDuration / 2,
                },
                target: TransitionTarget.ENTER,
            }, {
                fromStyle: {
                    ...TransitionConfig.SWITCH_RIGHT_MIDDLE,
                    ...TransitionConfig.Z_INDEX_LEVEL_1,
                },
                toStyle: {
                    ...TransitionConfig.SWITCH_START,
                    ...TransitionConfig.Z_INDEX_LEVEL_1,
                    duration: this.animationDuration / 2,
                },
                target: TransitionTarget.ENTER,
                label: AnimationLabel.NEXT,
            }];
        }
        // 切换——向右
        return [{
            fromStyle: {
                ...TransitionConfig.SWITCH_START,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.SWITCH_RIGHT_MIDDLE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.EXIT,
        }, {
            fromStyle: {
                ...TransitionConfig.SWITCH_RIGHT_MIDDLE,
                ...TransitionConfig.Z_INDEX_LEVEL_0,
            },
            toStyle: {
                ...TransitionConfig.SWITCH_END,
                ...TransitionConfig.Z_INDEX_LEVEL_0,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.EXIT,
            label: AnimationLabel.NEXT,
        }, {
            fromStyle: {
                ...TransitionConfig.SWITCH_END,
                ...TransitionConfig.Z_INDEX_LEVEL_0,
            },
            toStyle: {
                ...TransitionConfig.SWITCH_LEFT_MIDDLE,
                ...TransitionConfig.Z_INDEX_LEVEL_0,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.ENTER,
        }, {
            fromStyle: {
                ...TransitionConfig.SWITCH_LEFT_MIDDLE,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
            },
            toStyle: {
                ...TransitionConfig.SWITCH_START,
                ...TransitionConfig.Z_INDEX_LEVEL_1,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.ENTER,
            label: AnimationLabel.NEXT,
        }];
    }

    public getImplementationType(): ImplementationType {
        return ImplementationType.PRESERVE_3D;
    }
}
